module.exports = __webpack_public_path__ + "img/trial-success.07566aa8.svg";